// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `motes-media #media-container {
  position: relative;
  cursor: pointer;
}
motes-media #media-container .play-overlay {
  position: absolute;
  top: calc(50% - 25px);
  left: 0;
  width: 100%;
  color: white;
  text-align: center;
  opacity: 0;
  transition: 0.5s opacity;
}
motes-media #media-container .play-overlay .play-icon {
  font-size: 50px;
}
motes-media #media-container .play-overlay .loading-status {
  font-size: 14px;
}
motes-media #media-container .play-overlay.show {
  opacity: 1;
}
motes-media #media-container.disable-open-image {
  cursor: default;
}
motes-media #full-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: red;
}
motes-media #full-screen video, motes-media #full-screen img {
  max-width: 100%;
  max-height: calc(80vh - 120px);
  margin-top: 55px;
}
motes-media .media {
  position: relative;
  background: var(--motes-black);
  aspect-ratio: 16/9;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
  color: white;
}
motes-media .media .mediaImage {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  top: 50%;
  transform: translateY(-50%);
}
motes-media .media .play, motes-media .media .pause {
  margin: auto;
  display: flex;
  font-size: 30px;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  pointer-events: initial;
  transition: 0.1s;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  padding-left: 1px;
  padding-top: 6px;
  box-sizing: border-box;
  opacity: 0;
}
motes-media .media .pause {
  transition: opacity 0.3s linear;
  opacity: 0;
}
motes-media .media .fadeIn {
  transition: opacity 0.3 ease-in;
  opacity: 1;
}
motes-media .media .fadeOut {
  opacity: 0;
  transition: 2s;
}
motes-media .media:hover .play, motes-media .media:hover .pause {
  transform: scale(1.2);
  transition: 0.3s;
}
motes-media .fadeOutVideo {
  transition: opacity 0.4s ease-in;
  opacity: 0;
}
motes-media video {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  transition: opacity 0.8s ease-out;
  opacity: 1;
}
motes-media .mediaFullscreen {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  pointer-events: initial;
}
motes-media .copyright {
  color: white;
  opacity: 1;
  position: absolute;
  bottom: 4px;
  left: 4px;
  font-size: 11px;
  text-shadow: 0 0 2px black;
}
motes-media .expand, motes-media .exit-full {
  position: absolute;
  opacity: 1;
  color: white;
  bottom: -2px;
  right: 14px;
  font-size: 30px;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.8);
  color: rgba(255, 255, 255, 0.425);
  pointer-events: initial;
}
motes-media .expand:hover {
  color: rgba(255, 255, 255, 0.781);
}
motes-media .hide-expand {
  pointer-events: none;
  opacity: 0;
}
motes-media .exit-full {
  pointer-events: none;
  opacity: 0;
}
motes-media .exit-full:hover {
  color: rgba(255, 255, 255, 0.781);
}
motes-media .exit-show {
  pointer-events: initial;
  opacity: 1;
}
motes-media .experienceLoaded {
  font-size: 22px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/motes-media/motes-media.scss"],"names":[],"mappings":"AAEI;EACI,kBAAA;EACA,eAAA;AADR;AAGQ;EACI,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;AADZ;AAGY;EACI,eAAA;AADhB;AAIY;EACI,eAAA;AAFhB;AAMQ;EACI,UAAA;AAJZ;AAOQ;EACI,eAAA;AALZ;AAWI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AATR;AAUQ;EACI,eAAA;EACA,8BAAA;EACA,gBAAA;AARZ;AAYI;EACI,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AAVR;AAYQ;EACI,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;AAVZ;AAaQ;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EAAQ,OAAA;EAAS,SAAA;EAAW,QAAA;EAC5B,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,UAAA;AARZ;AAWQ;EACI,+BAAA;EACA,UAAA;AATZ;AAYQ;EACI,+BAAA;EACA,UAAA;AAVZ;AAaQ;EACI,UAAA;EACA,cAAA;AAXZ;AAeI;EACI,qBAAA;EACA,gBAAA;AAbR;AAgBI;EACI,gCAAA;EACA,UAAA;AAdR;AAiBI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,UAAA;AAfR;AAkBI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EAIA,UAAA;EACA,uBAAA;AAnBR;AA0BI;EACI,YAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,0BAAA;AAxBR;AA2BI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,uCAAA;EACA,iCAAA;EACA,uBAAA;AAzBR;AA4BI;EACI,iCAAA;AA1BR;AA6BI;EACI,oBAAA;EACA,UAAA;AA3BR;AA8BI;EACI,oBAAA;EACA,UAAA;AA5BR;AA+BI;EACI,iCAAA;AA7BR;AAgCI;EACI,uBAAA;EACA,UAAA;AA9BR;AAiCI;EACI,eAAA;AA/BR","sourcesContent":["motes-media {\n\n    #media-container {\n        position: relative;\n        cursor: pointer;\n\n        .play-overlay {\n            position: absolute;\n            top: calc(50% - 25px);\n            left: 0;\n            width: 100%;\n            color: white;\n            text-align: center;\n            opacity: 0;\n            transition: .5s opacity;\n\n            .play-icon {\n                font-size: 50px;\n            }\n\n            .loading-status {\n                font-size: 14px;\n            }\n        }\n        \n        .play-overlay.show {\n            opacity: 1;\n        }\n\n        &.disable-open-image {\n            cursor: default;\n        }\n    }\n\n    $size: 70px;\n\n    #full-screen {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 10;\n        background: red;\n        video, img {\n            max-width: 100%;\n            max-height: calc(80vh - 120px);\n            margin-top: 55px;\n        }\n    }\n\n    .media {\n        position: relative;\n        background: var(--motes-black);\n        aspect-ratio: 16/9;\n        overflow: hidden;\n        box-sizing: border-box;\n        cursor: pointer;\n        color: white;\n\n        .mediaImage {\n            position: absolute;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n\n        .play, .pause {\n            margin: auto;\n            display: flex;\n            font-size: 30px;\n            align-items: center;\n            justify-content: center;\n            position: absolute;\n            top: 0; left: 0; bottom: 0; right: 0;\n            pointer-events: initial;\n            transition: .1s;\n            width: 50px;\n            height: 50px;\n            border-radius: 50%;\n            background-color:  rgba(0,0,0,.4);\n            cursor: pointer;\n            padding-left: 1px;\n            padding-top: 6px;\n            box-sizing: border-box;\n            opacity: 0;\n        }\n\n        .pause {\n            transition:opacity 0.3s linear;\n            opacity:0;\n        }\n\n        .fadeIn {\n            transition:opacity 0.3 ease-in;\n            opacity:1;\n        }\n\n        .fadeOut {\n            opacity:0;\n            transition: 2s;\n        }\n    }\n\n    .media:hover .play, .media:hover .pause {\n        transform: scale(1.2);\n        transition: .3s;\n    }\n\n    .fadeOutVideo {\n        transition:opacity 0.4s ease-in;\n        opacity:0;\n    }\n\n    video {\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        width: 100%;\n        height : 100%;\n        transition:opacity 0.8s ease-out;\n        opacity: 1;\n    }\n\n    .mediaFullscreen {\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        // width: 100vw;\n        // height: 100vh;\n        //background-color: rgba(0,0,0,1);\n        z-index: 1;\n        pointer-events: initial;\n    }\n\n    video::-webkit-media-controls-fullscreen-button {\n        // display: none;\n    }\n\n    .copyright {\n        color: white;\n        opacity: 1;\n        position: absolute;\n        bottom: 4px;\n        left: 4px;\n        font-size: 11px;\n        text-shadow: 0 0 2px black;\n    }\n\n    .expand, .exit-full {\n        position: absolute;\n        opacity: 1;\n        color: white;\n        bottom: -2px;\n        right: 14px;\n        font-size: 30px;\n        text-shadow: 0 0 1px rgba(0,0,0,.8);\n        color: rgba(255, 255, 255, 0.425);\n        pointer-events: initial;\n    }\n\n    .expand:hover {\n        color: rgba(255, 255, 255, 0.781);\n    }\n\n    .hide-expand {\n        pointer-events: none;\n        opacity: 0;\n    }\n\n    .exit-full {\n        pointer-events: none;\n        opacity: 0;\n    }\n\n    .exit-full:hover {\n        color: rgba(255, 255, 255, 0.781);\n    }\n\n    .exit-show {\n        pointer-events: initial;\n        opacity: 1;\n    }\n\n    .experienceLoaded {\n        font-size: 22px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
